import { UserException } from '@/domain/user/exception/UserException'

export class InvalidEmailException extends UserException {

}
